(function(){
  var form=document.getElementById('BBSCartForm');
  if(!form)return;
  var changeUrl=form.getAttribute('data-change-url')||'/cart/change';
  var busy=false;
  function change(key,qty){
    if(busy)return;busy=true;
    fetch(changeUrl+'.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({id:key,quantity:qty})})
      .then(function(r){return r.json();})
      .then(function(){window.location.reload();})
      .catch(function(){busy=false;window.location.reload();});
  }
  form.querySelectorAll('.bbs-line').forEach(function(line){
    var key=line.getAttribute('data-key');
    var inp=line.querySelector('[data-bbs-qty]');
    var dec=line.querySelector('[data-bbs-dec]');
    var inc=line.querySelector('[data-bbs-inc]');
    var rm=line.querySelector('[data-bbs-remove]');
    if(dec&&inp)dec.addEventListener('click',function(){var c=parseInt(inp.value,10)||1;var v=Math.max(1,c-1);if(v!==c)change(key,v);});
    if(inc&&inp)inc.addEventListener('click',function(){var c=parseInt(inp.value,10)||1;change(key,c+1);});
    if(inp)inp.addEventListener('change',function(){change(key,Math.max(1,parseInt(inp.value,10)||1));});
    if(rm)rm.addEventListener('click',function(){change(key,0);});
  });
  var pa=document.getElementById('bbs-promo-apply'),pi=document.getElementById('bbs-promo-input');
  if(pa&&pi){
    var applyPromo=function(){var c=(pi.value||'').trim();if(c)window.location.href='/discount/'+encodeURIComponent(c)+'?redirect=/checkout';};
    pa.addEventListener('click',applyPromo);
    pi.addEventListener('keydown',function(e){if(e.key==='Enter'){e.preventDefault();applyPromo();}});
  }
})();
